import React from 'react';
import classnames from 'classnames';
import styles from 'components/Toolbar/Toolbar.scss';

const Toolbar = props => (
  <div className={classnames(styles.toolbar, styles[props.className])}>
    <div className={styles.title}>
      { props.section
        ?
          <div className={styles.section}>{props.section}</div>
        : null
      }
      <div className={styles.name}>
        <span className={styles.subsection}>
          {props.subsection}
        </span>
        <span className={styles.details}>
          <span>{props.details}</span>
          <span className={styles.subdetails}>{props.subdetails}</span>
        </span>
      </div>
    </div>
    <div className={styles.actions}>
      {props.children}
    </div>
  </div>
);

export default Toolbar;
